/**
 * Calculates the total height of an element, including its rendered height (content + padding + border)
 * and its own bottom margin. This is useful for summing heights of block elements in a flow.
 *
 * @param {HTMLElement} element - The element for which the total height will be calculated.
 * @returns {number} - The total height of the element including its rendered box and its bottom margin.
 */
export const getTotalHeight = element => {
  if (!element) return 0 // Manejar null o undefined

  const rect = element.getBoundingClientRect()
  const style = window.getComputedStyle(element)
  const marginBottom = parseInt(style.marginBottom, 10) || 0
  const calculatedHeight = rect.height + marginBottom

  return calculatedHeight
}
